import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { CenteredSpinner } from '@/components/ui/CenteredSpinner';
import { hasSeenWelcome } from '@/pages/welcome/welcomeStorage';
import { useOnboardingEnabled } from '@/hooks/useOnboardingEnabled';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading, accessState } = useAuth();
  const location = useLocation();
  const { data: onboardingEnabled } = useOnboardingEnabled();

  if (loading && !user) {
    return <CenteredSpinner fullScreen />;
  }

  if (!user) {
    // First-time visitors on this device see the public welcome landing.
    // Subsequent visits go straight to /auth to keep zero friction.
    // Quando o onboarding está desligado globalmente, sempre mandamos direto para /auth.
    const skipWelcome = onboardingEnabled === false || hasSeenWelcome();
    const target = skipWelcome ? '/auth' : '/welcome';
    return <Navigate to={target} state={{ from: location }} replace />;
  }

  // Authentication is not authorization. Never mount protected screens until
  // the server-side entitlement contract explicitly grants access.
  if (accessState !== 'allowed') {
    return <CenteredSpinner fullScreen />;
  }

  return <>{children}</>;
}
